export enum FeatureLayerType {
  TRAFFIC_REPORT = 'TRAFFIC_REPORT',
  BIKEABILITY = 'BIKEABILITY',
  WALKABILITY = 'WALKABILITY',
  VERKEHRSLAGE = 'VERKEHRSLAGE',
}
